<template>
  <div>
    <div id="modals-container"></div>
    <v-container>
      <v-row class="justify-center">
        <v-col cols="12" sm="11" lg="11" :class="['px-0']">
          <v-expansion-panels focusable>
            <v-expansion-panel
              v-for="(item, i) in sortedNotifications"
              :key="i"
              hover
              tabindex="0"
            >
              <v-expansion-panel-header
                :class="[
                  item.readed !== true ? 'status-failed-exp' : 'status-ok-exp',
                ]"
              >
                <v-row>
                  <v-col
                    cols="12"
                    sm="4"
                    md="3"
                    lg="3"
                    :class="[densityPadding]"
                  >
                    <div class="caption grey--text">Naslov</div>
                    <div class="text-capitalize font-weight-medium">{{ item.subject }}</div>
                  </v-col>
                  <v-col
                    v-if="!$vuetify.breakpoint.smAndDown"
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    :class="[densityPadding]"
                  >
                    <div class="caption grey--text">Status</div>
                    <div class="text-capitalize font-weight-medium">
                      {{ showStatus(item.readed) }}
                    </div>
                  </v-col>
                  <v-col
                    v-if="!$vuetify.breakpoint.mdAndDown"
                    cols="12"
                    md="2"
                    lg="2"
                    :class="[densityPadding]"
                  >
                    <div class="caption grey--text">Datum</div>
                    <div class="font-weight-medium">
                      {{ formatDate(item.created) }}
                    </div>
                  </v-col>
                  <v-col
                    v-if="!$vuetify.breakpoint.smAndDown"
                    cols="12"
                    sm="6"
                    md="3"
                    lg="3"
                    :class="[densityPadding]"
                  >
                    <div class="caption grey--text">Tip</div>
                    <div class="text-capitalize-first font-weight-medium">
                      {{ showType(item.type) }}
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="notification-content-wrapper">
                  <v-row dense class="mt-2">
                    <v-col cols="12" md="10" lg="8">
                      <p class="font-weight-bold mb-2">Obavijest</p>
                      <div v-html="item.text" class="notification-content"></div>
                    </v-col>
                  </v-row>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { auth, df } from '@/plugins/firebase'
// import state from '@/state'
import flow from '@/mixins/flow'
import applicationSettings from '@/mixins/applicationSettings'

export default {
  components: { },
  mixins: [flow, applicationSettings],
  inject: ['showLoader', 'hideLoader'],
  data: function () {
    return {
      notifications: [],
      currentNotifications: [],
      lastVisible: {},
      listeners: []
    }
  },
  computed: {
    sortedNotifications () {
      if (!this.notifications || this.notifications.length === 0) return []

      // Sort by created date only (newest first)
      return [...this.notifications].sort((a, b) => {
        const dateA = a.created || 0
        const dateB = b.created || 0
        return dateB - dateA // descending order (newest first)
      })
    }
  },
  watch: {
  },
  beforeDestroy () {
    if (this.listeners) {
      this.detachListeners()
    }
  },
  mounted () {
    const query = df.collection(`user_notifications/${auth.currentUser.uid}/notifications`)
      .orderBy('created', 'asc')

    const listener = query
      .onSnapshot((doc) => {
        if (doc.docs.length > 0) {
          this.notifications = []
          doc.docs.forEach((rec, key) => {
            this.notifications.push(rec.data())
          })
        } else {
          this.showNotif = false
          this.importantNotif = undefined
        }
      }
      )
    this.listeners.push(listener)
  },
  methods: {
    showType (type) {
      switch (type) {
        case 'CONFIRMATION':
          return 'Važna obavijest - potrebna potvrda'
        case 'IMPORTANT':
          return 'Važna obavijest'
        case 'NOTIFICATION':
          return 'Obavijest'
        case 'WARNING':
          return 'Obavijest'
      }
    },
    hoverOver (ref, item) {
      const container = this.$refs[ref]
      if (!container || !container[0]) return
      if (container[0].associateHeight < container[0].scrollHeight) {
        item[ref] = true
      }
    },
    showStatus (read) {
      switch (read) {
        case true:
          return 'Pročitano'
        case false:
          return 'Nepročitano'
      }
    },
    formatDate (timestamp) {
      if (!timestamp) return '-'

      // Handle epoch timestamp (seconds or milliseconds)
      const date = new Date(timestamp * 1000) // epoch is in seconds, convert to milliseconds

      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')

      return `${day}.${month}.${year}. ${hours}:${minutes}`
    },
    changeNotifStatus (notif) {
      df.doc(`user_notifications/${auth.currentUser.uid}/notifications/${notif.id}`).update({ readed: notif.read })
    }

  }
}
</script>
<style scoped>
/* Expansion Panel Header Padding */
.container >>> .v-expansion-panel-header {
  padding: 12px 16px !important;
  min-height: 64px !important;
}

/* Status Color Styling - Read Notifications (Green) */
.status-ok-exp {
  background: linear-gradient(135deg,
    rgba(76, 175, 80, 0.08) 0%,
    rgba(56, 142, 60, 0.06) 100%) !important;
  border-left: 4px solid rgba(76, 175, 80, 0.6) !important;
  backdrop-filter: blur(10px) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.status-ok-exp:hover {
  background: linear-gradient(135deg,
    rgba(76, 175, 80, 0.12) 0%,
    rgba(56, 142, 60, 0.1) 100%) !important;
  border-left-color: rgba(76, 175, 80, 0.8) !important;
}

/* Status Color Styling - Unread Notifications (Red) */
.status-failed-exp {
  background: linear-gradient(135deg,
    rgba(244, 67, 54, 0.08) 0%,
    rgba(211, 47, 47, 0.06) 100%) !important;
  border-left: 4px solid rgba(244, 67, 54, 0.6) !important;
  backdrop-filter: blur(10px) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.status-failed-exp:hover {
  background: linear-gradient(135deg,
    rgba(244, 67, 54, 0.12) 0%,
    rgba(211, 47, 47, 0.1) 100%) !important;
  border-left-color: rgba(244, 67, 54, 0.8) !important;
}

/* Expansion Panel Styling */
.v-expansion-panel {
  margin-bottom: 8px !important;
  border-radius: 8px !important;
  overflow: hidden;
}

.v-expansion-panel::before {
  box-shadow: none !important;
}

/* Notification Content Wrapper with Border */
.notification-content-wrapper {
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  border-radius: 8px !important;
  background: rgba(255, 255, 255, 0.5) !important;
  backdrop-filter: blur(10px) !important;
  padding: 16px !important;
  margin: 8px 0 !important;
}

/* Notification Content Styling */
.notification-content {
  font-size: 14px;
  line-height: 1.6;
  color: rgba(70, 70, 80, 0.9);
}

.notification-content >>> p {
  margin-bottom: 8px;
}

/* Font Weight for Text */
.font-weight-medium {
  font-weight: 500 !important;
}

.myTest >>> .vm--modal {
  top: 100px !important;
}
</style>
